import { render } from "./ProductsCategory.vue?vue&type=template&id=099ff211&scoped=true"
import script from "./ProductsCategory.vue?vue&type=script&lang=js"
export * from "./ProductsCategory.vue?vue&type=script&lang=js"

import "./ProductsCategory.vue?vue&type=style&index=0&id=099ff211&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-099ff211"]])

export default __exports__